import styled from 'styled-components';
import Button from '../../../../../../../components/Button';
import { Colors } from '../../../../../../../constants';


const FormContent = styled.div`
  width: 100%;
  padding: 0 48px;
`;

const FormTitle = styled.span`
  color: var(--luft-primary);
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TrackingActiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

const TrackingActive = styled.span`
  color: var(--luft-primary);
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 18px;
`;

const TrackingDisclaimer = styled.span`
  font-style: italic;
  font-size: 16px;
  margin-top: 18px;

  color: #999999;
`;

const ToggleContainer = styled.div`  
  display: flex;
  align-items: center;  
`;

const ActionButtonsContainer = styled.div`
  display: flex;  
  justify-content: flex-end;
  margin-top: 48px;
`;

const StyledButton = styled(Button)`
  &:first-child {
    background: #C4C4C4;
    margin-right: 16px;
  }

  text-transform: uppercase;
`;

export const CheckBoxLabel = styled.span`
  display: block;
  margin-left: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 12px;
  text-align: right;
  color: ${({ checked }) => (checked ? Colors.SECONDARY_BLUE : Colors.LIGHT_OPACITY_GREY)} !important;  
`;

export const S = {
  Form,
  FormTitle,
  FormContent,
  TrackingActive,
  TrackingDisclaimer,
  TrackingActiveContainer,
  ToggleContainer,
  ActionButtonsContainer,
  StyledButton,
  CheckBoxLabel,
};
